import { ErrorBoundary as SentryErrorBoundary } from "@sentry/react";
import React from "react";
// import { useRouteError } from "react-router-dom";
import { IComponentParent } from "sonobello.utilities.react";

import SomethingWentWrongView from "../../../components/views/SomethingWentWrongView";
import ReportingDelegatingErrorBoundary from "../Components/ReportingDelegatingErrorBoundary";
// import RoutingDelegatingErrorBoundary from "../Components/RoutingDelegatingErrorBoundary";
import useReportSomethingWentWrong from "../Hooks/UseReportSomethingWentWrong";
import { IErrorBoundaryProps, IReportingErrorBoundaryProps } from "../Types/IDelegatingErrorBoundary";

/** An error boundary for handling component exceptions implemented with the native Sentry utility. */
const ComponentErrorBoundary: React.FC<IErrorBoundaryProps> = ({ Fallback, onError, children }) => (
  <SentryErrorBoundary fallback={Fallback} onError={onError}>
    {children}
  </SentryErrorBoundary>
);

/**
 * @remarks we force cast {@link useRouteError} because the Typescript types are not provided by the library
 * @remarks commenting this out until we can use it with a more recent version of React Router
 */
// const RoutingBoundary: React.FC<IErrorBoundaryProps> = props => (
//   <RoutingDelegatingErrorBoundary
//     {...props}
//     useRoutingError={useRouteError as () => Error | null | undefined}
//     DelegatedErrorBoundary={ComponentErrorBoundary}
//   />
// );

/** Composes the application's outermost error boundary to use a 2 layer chain of delegating handlers;
 * 1) reporting side-effects 2) component errors respectively.
 */
const AppErrorBoundary: React.FC<IReportingErrorBoundaryProps & IComponentParent> = ({ children, ...rest }) => (
  <ReportingDelegatingErrorBoundary
    useReportError={useReportSomethingWentWrong}
    // DelegatedErrorBoundary={RoutingBoundary}
    DelegatedErrorBoundary={ComponentErrorBoundary}
    Fallback={<SomethingWentWrongView />}
    {...rest}
  >
    {children}
  </ReportingDelegatingErrorBoundary>
);

export default AppErrorBoundary;
